module.exports = __webpack_public_path__ + "img/cl.e850b3b9.png";